import { FormItem, MenuPresets } from '@framework/form';
import { yup } from '@framework/validation';
import React from 'react';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema';
import { IDividerWidget } from './IDividerWidget';

export const DividerWidgetConfigSchema = CommonGraphicWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Divider).required(),
  title: RichTextAdvancedSchema.optional().label('Titolo'),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IDividerWidget>;

export interface IDividerWidgetConfigComponentProps
  extends IWidgetComponentProps<IDividerWidget> {}

export function DividerWidgetConfigComponent(
  props: IDividerWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);

  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />

      <FormItem name="title" label="Testo">
        <RichTextAdvancedInput
          name="title"
          menus={MenuPresets.Inline}
          rows={3}
        />
      </FormItem>
    </div>
  );
}
